// src/components/DoughnutChart.js
import React from 'react';
import ReactApexChart from 'react-apexcharts';

const DoughnutChart = (props) => {
  const chartData = {
    labels: ['Category A', 'Category B', 'Category C', 'Category D'],
    series: [30, 20, 15, 35], // The data values for each category
  };

  const chartOptions = {
    chart: {
      type: 'donut',
    },
    labels: chartData.labels,
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
      },
    },
  };

  return (

    <div className='Polar'>
    <div className='row'>
      <div className='col-lg-5'>
        <div className='componentNameC'>{props.prams.prams.component}</div>
      </div>
    </div>
    <div className="p-2 Polar1">
        <ReactApexChart options={chartOptions} series={chartData.series} type="donut" height='200%' />
    </div>
  </div>
 );
};

export default DoughnutChart;
